module.exports = __webpack_public_path__ + "static/media/james.7f8aacde.jpg";